import apiUrl from "../../pages/config";
import ApiRequestType from "../apiRequestType";
import ApiRequestor from "../apiRequestor";
import axios from "../axios";

const FestivalService = () => {
    const requestor = new ApiRequestor(axios);
    const getFestivalDetails = async (slug) => {
        const url = `${apiUrl}/festival/${slug}`;
        const apiResponse = await requestor.makeRequest(
            ApiRequestType.GET,
            url
        );
        return apiResponse;
    };

    const getFestivals = async (page) => {
        const url = `${apiUrl}/festival/?page=${page}`;
        const apiResponse = await requestor.makeRequest(
            ApiRequestType.GET,
            url
        );
        return apiResponse;
    };
    return { getFestivalDetails, getFestivals };
};

export default FestivalService;
